<template lang="pug">
div
  .result-no-workers.notification(v-if="!isLoading && (!workerCount || isLastUpdateMoreThan15MinAgo)")
    p You are currently offline 😞 If you just started mining please be patient, it can take up to 10 minutes for your workers to show up!

  .box-summary.box.fs-16.fw-400(v-if="workerCount")
    div
      span(v-if="isLastUpdateMoreThan15MinAgo") Your last activity was having 
      span(v-else) You currently have 
      b(v-if='workerCount === 1') {{ workerCount }} worker online 
      b(v-else) {{ workerCount }} workers online 
      span connected to 
      b(v-if='algorithmCount  === 1') {{ algorithmCount }} algorithm 
      b(v-else) {{ algorithmCount }} algorithms 
      span with a total hash rate of 
      template(v-for="item, index in hashrates")
        b {{ item.value }} ({{ item.name | capitalize }})
        span(v-if="index < hashrates.length - 2") ,&nbsp;
        span(v-else-if="index === hashrates.length - 2") &nbsp;and&nbsp;
    div.fs-11.mt-10
      span(:class="{'animate-long': updated}") Last updated {{ timeAgo }}

  ListEvents(ref="listRef", :uuid="uuid" :isLoadingParent="isLoading" @goToTab="goToTab")

</template>

<script>
import { apiGet } from '../util/general'
import ListEvents from './c_tab_live_events'
import dayjs from 'dayjs'
export default {
  name: 'c_tab_live',
  props: ['uuid', 'summary'],
  components: {
    ListEvents
  },
  data() {
    return {
      isLoading: true,
      algorithmCount: null,
      hashrates: [],
      workerCount: null,
      lastUpdate: null,
      updated: false,
      timeInterval: null,
      timeAgo: null,
      isLastUpdateMoreThan15MinAgo: false
    }
  },
  mounted() {
    let vm = this

    var updateLocale = require('dayjs/plugin/updateLocale')
    dayjs.extend(updateLocale)

    const customRelativeTime = {
      future: 'in %s seconds',
      past: '%s ago',
      s: '%d seconds',
      m: '1 minute',
      mm: '%d minutes',
      h: '1 hour',
      hh: '%d hours',
      d: '1 day',
      dd: '%d days',
      M: '1 month',
      MM: '%d months',
      y: '1 year',
      yy: '%d years'
    };
    dayjs.updateLocale('en', { relativeTime: customRelativeTime });

    vm.timeInterval = setInterval(vm.updateTimeAgo, 1000)
  },
  unmounted() {
    clearInterval(this.timeInterval)
    this.clearRelativeTime()
  },
  beforeDestroy() {
    clearInterval(this.timeInterval)
    this.clearRelativeTime()
  },
  methods: {
    addEvent(item) {
      this.$refs.listRef.addEvent(item)
    },
    updateSummary() {
      let vm = this
      if (!vm.isLoading) {
        vm.updated = true
        vm.algorithmCount = vm.summary.algorithmCount
        vm.workerCount = vm.summary.workerCount
        vm.hashrates = vm.summary.hashrates
        vm.lastUpdate = vm.summary.lastUpdate
        clearInterval(vm.timeInterval)
        vm.updateTimeAgo()
        vm.timeInterval = setInterval(vm.updateTimeAgo, 1000)
        setTimeout(function () {
          vm.updated = false
        }, 1310)
      }
    },
    fetch() {
      let vm = this
      vm.isLoading = true
      vm.$emit('startLoading')

      let url = '/v5/account/' + vm.uuid + '/summary'

      let obj = {}
      apiGet(vm, url, obj, function (data) {
        if (!data.success) {
          vm.$store.dispatch('notifyError', data.msg)
        } else {
          if (data && data.data && data.data.raw && data.data.raw.worker_count) {
            vm.algorithmCount = data.data.raw.algorithm_count
            vm.workerCount = data.data.raw.worker_count
            let hashrates = data.data.raw.hr
            vm.hashrates = Object.entries(hashrates).map(([name, value]) => ({ name, value }))
            vm.lastUpdate = data.data.timestamp
          } else {
            vm.algorithmCount = null
            vm.workerCount = null
            vm.hashrated = []
            vm.lastUpdate = null
          }
          vm.updateTimeAgo()

          clearInterval(vm.timeInterval)
          vm.timeInterval = setInterval(vm.updateTimeAgo, 1000)

          if (vm.$refs.listRef && typeof vm.$refs.listRef.fetch === 'function') {
            vm.$refs.listRef.fetch(true)
          }
        }
      }, function (err) {
        console.error('Error:', err.message)
        vm.$store.dispatch('notifyError', err.message)
      }, function () {
        vm.isLoading = false
        vm.$emit('stopLoading')
      })
    },
    goToTab(tab) {
      this.$emit('goToTab', tab)
    },
    updateTimeAgo() {
      let vm = this
      if (vm.lastUpdate) {
        vm.timeAgo = dayjs().to(dayjs(vm.lastUpdate))
        const differenceInMinutes = (new Date() - new Date(this.lastUpdate)) / 1000 / 60;

        vm.isLastUpdateMoreThan15MinAgo = differenceInMinutes > 15

        if (differenceInMinutes >= 1) {
          clearInterval(vm.timeInterval)
          vm.timeInterval = setInterval(vm.updateTimeAgo, 60000)
        }
      }
    },
    clearRelativeTime() {
      const customRelativeTime = {
        future: 'in %s seconds',
        past: '%s ago',
        s: 'a few seconds',
        m: '1 minute',
        mm: '%d minutes',
        h: '1 hour',
        hh: '%d hours',
        d: '1 day',
        dd: '%d days',
        M: '1 month',
        MM: '%d months',
        y: '1 year',
        yy: '%d years'
      };
      dayjs.updateLocale('en', { relativeTime: customRelativeTime });
    }
  }
}
</script>

<style lang="stylus" scoped>
.padding-no-results
  padding: 0px 0px 25px 10px

.live-list
  padding-bottom: 2px
  .live-item:hover + .live-item
    border-top: 1px transparent solid;
  .live-item
    display: flex;
    align-items: center
    border-top: 1px solid #dbdbdb;
    padding: 0.4rem 15px

    &:first-child
      border-top: 1px transparent solid;
      padding-top: 7px

    &:hover
      border-radius: 6px; 
      box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
      border-top: 1px transparent solid;
    .live-icon
      font-size: 20px; 
      text-align: right; 
      width: 20px; 
      padding: 0px 30px 0px 15px;
      display: flex;
      justify-content: center;
      align-items: center;
    .live-description
      flex: 1;
      text-align: left;
      font-size: 13px
    .live-external-link
      font-size: 20px; 
      text-align: center;
      i
        color: #919191;

.box-summary
  &.updated
    background-color: red;
html.dark, body.dark
  .box-summary
    background-color: transparent
    color #ffffff
    box-shadow none
    border 1px solid #dbdbdb
</style>



// WEBPACK FOOTER //
// c_tab_live.vue?77b0d2b6